import config from '../../../../utils/config';

export const URL_SUBSCRIPTION = config().subscriptions;

export const URL_GET_EXIST_REPORT_BY_ID = (authIdInputValue): string => (
  `${URL_SUBSCRIPTION}?customer_id=${authIdInputValue}`
);
